import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BaseAsyncValue } from '../../../shared/models/async-value';
import { getOneClickSelectedOrder } from '../../selectors/one-click-orders.selector';
import { receivingPersonWithOrder } from '@ordersnproducts/modules/one-click-order/selectors/one-click-receiving-person.selector';

export class OneClickReceivingPersonProvider extends BaseAsyncValue<string> {
  getValue(): Observable<string> {
    return this.store.select(getOneClickSelectedOrder).pipe(
      filter(order => !!order && !!order.contact && !!order.contact.contactName),
      map(order => order.contact),
      map(contact => {
        return `${contact.contactName} - ${contact.contactPhone}`;
      }),
    );
  }
}
export class OneClickHasReceivingPersonAndOrderProvider extends BaseAsyncValue<boolean> {
  getValue(): Observable<boolean> {
    return this.store.select(receivingPersonWithOrder).pipe(
      map(result => {
        return (
          !!result.order ||
          (result.receivingPersons &&
            !!result.receivingPersons.length &&
            !result.oneClickState.oneClickOrders.addingReceivingPerson)
        );
      }),
    );
  }
}
export class OneClickNoReceivingPersonAndOrderProvider extends BaseAsyncValue<boolean> {
  getValue(): Observable<boolean> {
    return this.store.select(receivingPersonWithOrder).pipe(
      map(result => {
        return (
          !!result.order ||
          (result.receivingPersons && !result.receivingPersons.length) ||
          result.oneClickState.oneClickOrders.addingReceivingPerson
        );
      }),
    );
  }
}
